/**
  Update FAQ 'Does this cane come with a tip'question
  implemented: sections\main-product.liquid, snippets\product-faq-tab-content.liquid
*/
document.addEventListener("DOMContentLoaded", function () {
  
  const scriptVariantsData = document.querySelector("script#tip-meta-data").innerHTML
  const variantsData = JSON.parse(scriptVariantsData);
  console.log( "tip data", variantsData);

  const tip_el = document.querySelector('[ data-js-product-tip-size]')
  if(!tip_el){
    return console.log("Cant find DOM element for tip size")
  }

    //main product with tip size  - first render by metafield
    //   if(variantsData['main-product'].tip_size !== 'null'){
    //      tip_el.innerHTML = `Yes, this cane comes with a <strong >${variantsData['main-product'].tip_size} mm tip.</strong>`
    //      console.log("main tip size with number", variantsData['main-product'].tip_size ) 
    //   }

    //   const main_sku = variantsData['main-product'].sku
    //   const variant_sku =  variantsData[main_sku]
    //   console.log("variant sku", variant_sku)

    // variant with tip size 
    // if(variant_sku.tip_size !== 'null'){
    //     tip_el.innerHTML = `Yes, this cane comes with a <strong >${variant_sku.tip_size} mm tip</strong>.`
    //     return console.log("variant tip size with number", variant_sku.tip_size ) 
    // }

    // variant without tip size first render by metafield?
    // tip_el.innerText = `No, this cane comes without a tip.`


  function updateTipSize(sku = ''){
    const data = variantsData[sku] || variantsData[sku].main-product
    console.log('SKU onchange faq', sku, data)

    if(!data){
        return console.log('Cant find data for tip value onchange')
    }

    const faq_el = document.querySelector('[data-js-product-tip-size]')
    if(!faq_el){
        return console.log('Cant find FAQ tip value onchange')
    }

    // main product - tip is null
    if(data.tip_size === 'null'){
        faq_el.innerHTML = `Yes, this cane comes with a <strong >${variantsData['main-product'].tip_size} mm tip.</strong>`
        return;
    }

    // variant with value
    faq_el.innerHTML = `Yes, this cane comes with a <strong >${data.tip_size} mm tip.</strong>.`

  }

  window.updateTipSize = updateTipSize;

  
    


  
})